export default __webpack_public_path__ + "static/p3-431ea0657ce130d8a0b5ad845f05e8ea.png";